import PropTypes from 'prop-types';
import React from 'react';
import Link from 'next/link';
import Button from '@components/Shared/Buttons/Button';

import VisibilitySensor from 'react-visibility-sensor';
import noop from '@utils/noop';

import { StyledSectionContent } from './SectionContent.styled';

class SectionContent extends React.Component {
  constructor() {
    super();

    this.state = {
      isVisible: false,
    };

    this.visibilityChange = this.visibilityChange.bind(this);
  }

  visibilityChange(isVisible) {
    this.setState({
      isVisible: isVisible,
    });
  }

  render() {
    return (
      <VisibilitySensor
        partialVisibility={true}
        minTopValue={this.props.smallScreen ? 50 : 300}
        onChange={this.visibilityChange}
        active={!this.state.isVisible}
      >
        <StyledSectionContent visible={this.state.isVisible ? true : false}>
          <h3 className="h1">{this.props.header ? this.props.header : ''}</h3>
          <p className="standard">{this.props.blurb ? this.props.blurb : ''}</p>
          <Button
            className={this.props.cta.class}
            aria-label={this.props.cta.label}
            automationId={this.props.cta.label}
            onDarkBg={true}
            nextJSUrl={this.props.cta.url}
            linkComponent={Link}
            text={
              this.props.cta && this.props.cta.label ? this.props.cta.label : ''
            }
            onClick={this.props.cta.onClick || noop}
          />
        </StyledSectionContent>
      </VisibilitySensor>
    );
  }
}

SectionContent.propTypes = {
  blurb: PropTypes.any,
  cta: PropTypes.shape({
    class: PropTypes.any,
    label: PropTypes.any,
    onClick: PropTypes.any,
    url: PropTypes.any,
  }),
  header: PropTypes.any,
  smallScreen: PropTypes.any,
};

export default SectionContent;
